/**
 * @generated SignedSource<<f866863d84d13607b8167923474d9fa9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNodeSecurity_preventDownload_Mutation$variables = {
  nodeIds: ReadonlyArray<string>;
};
export type useNodeSecurity_preventDownload_Mutation$data = {
  readonly preventDownload: {
    readonly nodes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"useNodeSecurity_node">;
    }>;
  } | null;
};
export type useNodeSecurity_preventDownload_Mutation = {
  response: useNodeSecurity_preventDownload_Mutation$data;
  variables: useNodeSecurity_preventDownload_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeIds"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nodeIds",
        "variableName": "nodeIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      }
    ],
    "type": "File",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v4/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  },
  {
    "kind": "InlineFragment",
    "selections": (v4/*: any*/),
    "type": "PendingFile",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNodeSecurity_preventDownload_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NodeSecurityPreventDownloadMutationPayload",
        "kind": "LinkedField",
        "name": "preventDownload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useNodeSecurity_node"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNodeSecurity_preventDownload_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NodeSecurityPreventDownloadMutationPayload",
        "kind": "LinkedField",
        "name": "preventDownload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isNode"
              },
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorizationResult",
                    "kind": "LinkedField",
                    "name": "canUpdateSecurity",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "preventDownload",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasWatermark",
                    "storageKey": null
                  }
                ],
                "type": "HasNodeSecurityInterface",
                "abstractKey": "__isHasNodeSecurityInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "folderItemContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "FolderItem",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "vaultItemContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "VaultItem",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "draftVaultItemContent",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "VaultDraftItem",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72ade939e1b51bd011f6c6b6ec38e867",
    "id": null,
    "metadata": {},
    "name": "useNodeSecurity_preventDownload_Mutation",
    "operationKind": "mutation",
    "text": "mutation useNodeSecurity_preventDownload_Mutation(\n  $nodeIds: [ID!]!\n) {\n  preventDownload(input: {nodeIds: $nodeIds}) {\n    nodes {\n      __typename\n      ...useNodeSecurity_node\n      id\n    }\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ee40a1caf84671e44683157544e3b25";

export default node;
